if (!customElements.get('image-slider')) {
  class ImageSlider extends HTMLElement {
    constructor() {
      super();
      this.slidesLength = this.querySelectorAll('.swiper-slide').length;
      this.videoSlides = this.querySelectorAll('[data-slide-video]');
      this.swiperRoot = this.querySelector('[data-swiper]');
      this.swiperPagination = this.querySelector('[data-swiper-pagination]');
      if (!this.swiperPagination && this.nextElementSibling.hasAttribute('data-swiper-pagination')) {
        this.swiperPagination = this.nextElementSibling;
      }
      this.swiperButtons = this.querySelector('[data-swiper-buttons]');
      this.swiperButtonPrev = this.querySelector('[data-swiper-button-prev]');
      this.swiperButtonNext = this.querySelector('[data-swiper-button-next]');
      this.settings = {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        loop: true,
        init: false,
        preloadImages: false,
        watchSlidesProgress: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          prevEl: this.swiperButtonPrev,
          nextEl: this.swiperButtonNext
        },
        pagination: {
          el: this.swiperPagination
        },
        on: {
          slideChange: function () {
            let currentSlide = this.slides[this.activeIndex];
            if (currentSlide.querySelector('[data-slide-video]')) {
              const iframe = currentSlide.querySelector('[data-slide-video]');
              const srcUrl = new URL(iframe.getAttribute('src'));
              srcUrl.searchParams.set("autoplay","true");
              iframe.removeAttribute('src');
              iframe.setAttribute('src', srcUrl);
            }
            currentSlide = this.slides[this.realIndex];
            if (this.slides[this.realIndex].querySelector('[data-slide-video]')) {
              const iframe = currentSlide.querySelector('[data-slide-video]');
              const srcUrl = new URL(iframe.getAttribute('src'));
              srcUrl.searchParams.set("autoplay","true");
              iframe.removeAttribute('src');
              iframe.setAttribute('src', srcUrl);
            }
          }
        }
      }
      if (this.getAttribute('data-swiper-settings')) {
        const o = JSON.parse(this.getAttribute('data-swiper-settings'));
        Object.assign(this.settings, o);
      }
      Object.keys(this.settings.breakpoints).forEach((key,i) => {
        key = parseFloat(key);
        if (window.innerWidth > key) {
          this.currentBreakpointSettings = this.settings.breakpoints[key];
        }
      });
    }

    connectedCallback() {
      this.swiper = new Swiper(this.swiperRoot, this.settings);
      this.swiper.on('resize', e => {
        Object.keys(this.settings.breakpoints).forEach((key,i) => {
          key = parseFloat(key);
          if (window.innerWidth > key) {
            this.currentBreakpointSettings = this.settings.breakpoints[key];
          }
        });
      });
      if (this.slidesLength === 1) {
        this.swiper.disable();
      } else {
        this.swiperButtons.querySelectorAll('.swiper-button-lock').forEach(el => {
          el.classList.remove('swiper-button-lock')
        });
      }
      this.swiper.init();
      if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onSectionEvent.bind(this));
      }
    }
    disconnectedCallback() {
      if (Shopify && Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.onSectionEvent.bind(this));
      }
    }
    onSectionEvent(e) {
      const { type, detail, target } = e;
      if (type == "shopify:block:select" && this.contains(e.target)) {
        this.swiper.slideTo(target.getAttribute('data-index'))
      }
    }
  }
  customElements.define('image-slider', ImageSlider);
}
